<template>
    <div class="footer">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040558" style="text-decoration:none;height:20px;line-height:20px;">
            <img src="/img/备案图标.png" style="float:left;"/>
            <span class="wording">京公网安备 11010502040558号</span>
        </a>
        <span class="wording">京ICP备20010542</span>
    </div>
</template>

<script>
    export default {
        name: "vFooter"
    }
</script>

<style scoped>
.footer {
    background: #f9f9f9;
    height: 25px;
    margin:0 auto;
    padding:2px 0;
    display: inline-block;
    width: 100%;
    alignment: center;
}
.wording{
    float:left;
    height:20px;
    line-height:20px;
    margin: 0px 0px 0px 5px;
    color:#939393;
}
</style>